module.exports = __webpack_public_path__ + "static/media/btn.cbedc5b9.png";